// src/pages/Clientes.js
import React, { useEffect, useState } from "react";
import { db } from "../../firebaseConfig";
import { ref, get } from "firebase/database";
import "../styles/clientes.css";
import {
  Box,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const Clientes = () => {
  const [clientes, setClientes] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchClientes = async () => {
      try {
        const imoveisRef = ref(db, "imoveis");
        const snapshot = await get(imoveisRef);

        if (snapshot.exists()) {
          const data = snapshot.val();
          const ownersList = [];

          // percorre todos os imóveis e coleta proprietários
          Object.entries(data).forEach(([uid, item]) => {
            const owner = item.ownerInfo || null;
            if (!owner) return;

            ownersList.push({
              id: uid,
              nome: owner.nome || "-",
              sobrenome: owner.sobrenome || "-",
              cpf: owner.cpf || "-",
              telefone: owner.telefone || "-",
              birth: owner.birth || "-",
              email: owner.email || "-",
            });
          });

          // 🔹 Remove duplicados apenas se nome + telefone + cpf forem idênticos
          const uniqueOwners = [];
          const seen = new Set();

          ownersList.forEach((o) => {
            const key = `${o.nome.toLowerCase()}|${o.telefone}|${o.cpf}`;
            if (!seen.has(key)) {
              seen.add(key);
              uniqueOwners.push(o);
            }
          });

          // Ordena alfabeticamente
          uniqueOwners.sort((a, b) =>
            a.nome.localeCompare(b.nome, "pt-BR", { sensitivity: "base" })
          );

          setClientes(uniqueOwners);
        }
      } catch (err) {
        console.error("Erro ao buscar clientes:", err);
      }
    };

    fetchClientes();
  }, []);

  // 🔍 Filtro de pesquisa
  const filteredClientes = clientes.filter((c) =>
    `${c.nome} ${c.sobrenome} ${c.cpf}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  return (
    <Box p={4} width={1000} ml={30}>

      <Typography variant="h4" gutterBottom>
        Clientes ({filteredClientes.length})
      </Typography>

      {/* Campo de pesquisa */}
      <TextField
        label="Pesquisar cliente..."
        variant="outlined"
        fullWidth
        margin="normal"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": { borderColor: "var(--verde)" },
            "&:hover fieldset": { borderColor: "var(--verde)" },
            "&.Mui-focused fieldset": { borderColor: "var(--verde)" },
          },
          "& .MuiInputLabel-root": { color: "var(--verde)" },
          "& .MuiInputLabel-root.Mui-focused": { color: "var(--verde)" },
        }}
      />

      {/* Tabela de clientes */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              <TableCell><b>Nome</b></TableCell>
              <TableCell><b>Sobrenome</b></TableCell>
              <TableCell><b>CPF</b></TableCell>
              <TableCell><b>Telefone</b></TableCell>
              <TableCell><b>Data de Nascimento</b></TableCell>
              <TableCell><b>Email</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredClientes.length > 0 ? (
              filteredClientes.map((cliente, index) => (
                <TableRow key={`${cliente.id}-${index}`}>
                  <TableCell>{cliente.nome}</TableCell>
                  <TableCell>{cliente.sobrenome}</TableCell>
                  <TableCell>{cliente.cpf}</TableCell>
                  <TableCell>{cliente.telefone}</TableCell>
                  <TableCell>{cliente.birth}</TableCell>
                  <TableCell>{cliente.email}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  Nenhum cliente encontrado
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Clientes;
